// extracted by mini-css-extract-plugin
export default {"title":"bf9460e984","inner_title":"a816cfa120","charge_btn":"_4b481affbb"};